module.exports = __webpack_public_path__ + "files/a6cc5f2f5b174ca5d7079f7aac287a77.png";